import { observer } from "mobx-react-lite";
import { useStores } from "../../stores/rootStore";
import { Box, Typography, Switch, Sheet } from "@mui/joy";

const LogViewer = observer(function LogViewer() {
  const { logStore, interview } = useStores();
  
  const formatRelativeTime = (timestamp) => {
    if (!interview.startTimeMs) {
      return new Date(timestamp).toLocaleTimeString() + '.' + new Date(timestamp).getMilliseconds().toString().padStart(3, '0');
    }
    const relativeMs = timestamp - interview.startTimeMs;
    const totalSeconds = Math.floor(relativeMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const ms = relativeMs % 1000;
    return `+${minutes}:${seconds.toString().padStart(2, '0')}.${ms.toString().padStart(3, '0')}`;
  };
  
  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography level="title-sm">Dev Logs</Typography>
        <Switch checked={logStore.devMode} onChange={e => logStore.setDevMode(e.target.checked)} />
        <Typography level="body-xs" sx={{ opacity: 0.7 }}>({logStore.entries.length} entries)</Typography>
        {logStore.devMode && (
          <Typography level="body-xs" sx={{ ml: 'auto', cursor: 'pointer' }} onClick={() => logStore.clear()}>Clear</Typography>
        )}
      </Box>
      {logStore.devMode && (
        <Sheet variant="outlined" sx={{ mt: 1, maxHeight: 600, overflow: 'auto', p: 1, fontFamily: 'monospace', fontSize: 12 }}>
          {logStore.entries.slice().reverse().map(e => (
            <Box key={e.id} sx={{ mb: 0.5 }}>
              <Typography level="body-xs" component="span" sx={{ fontWeight: 'bold' }}>{formatRelativeTime(e.ts)} </Typography>
              <Typography level="body-xs" component="span" color="neutral">[{e.tag}]</Typography>{' '}
              <Typography level="body-xs" component="span" color="neutral" sx={{ opacity: 0.8 }}>{JSON.stringify(e.payload)}</Typography>
            </Box>
          ))}
          {!logStore.entries.length && <Typography level="body-xs">No logs yet.</Typography>}
        </Sheet>
      )}
    </Box>
  );
});

export default LogViewer;
